import axios from "axios";
import { config } from "../config/config";
import { endpoints } from "../apiEndpoints/apiEndpoints";

// Type for API response interface
const ApiResponse = {};
console.log("Config object:", config);
console.log("Config URL:", config?.url);
console.log("Raw env variable:", process.env.REACT_APP_BASE_URL);
const urltoken = new URLSearchParams(window.location.search).get('token');

// Create an Axios instance
const api = axios.create({
  baseURL: config?.url,
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
  },
});

// Request Interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token");
    if (token || urltoken) {
      config.headers['Authorization'] = `Bearer ${token ? token : urltoken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);                                                                       

// Response Interceptor
api.interceptors.response.use(
  (response) => {
    try {
      // Log response details for debugging (temporary)
      console.log('[API RESPONSE]', response.config?.method?.toUpperCase(), response.config?.url, 'status:', response.status, 'data:', response.data);
    } catch (e) {
      // ignore logging errors
    }
    return response;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      switch (status) {
        case 401:
          console.error("Unauthorized! Logging out...");
          localStorage.clear();
          window.location.href = "/login";
          break;
        case 403:
          console.error("Access denied!");
          break;
        case 500:
          console.error("Server error!");
          break;
        default:
          console.error(data?.message || "An unknown error occurred");
      }
    } else {
      console.error("Network error: ", error.message);
    }
    return Promise.reject(error);
  }
);

// CRUD API Helper Methods
const apiService = {
  get: (url, params = {}) =>
    api.get(url, { params }),

  post: (url, data, config) =>
    api.post(url, data, config),

  put: (url, data, config) =>
    api.put(url, data, config),
  patch: (url, data, config) =>
    api.patch(url, data, config),

  // ✅ Updated delete method to support request body
  delete: (url, data, config) =>
    api.delete(url, { data, ...config }),

  postFormData: (url, formData) =>
    api.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  putFormData: (url, formData) =>
    api.put(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  
patchFormData: (url, formData) =>
    api.patch(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  
};

// Export the API service
export default apiService;